import React from 'react';
import ContactUs from '../components/ContactUs'; // adjust path as necessary

const ContactUsPage = () => {
  return (
    <>
      <ContactUs />
    </>
  );
};

export default ContactUsPage;
